// extracted by mini-css-extract-plugin
export default {"default":"Container__default--gzmgS","full-width":"Container__full-width--uXrMg"};